define([
	"dojo/domReady",
	"./nmCryptoKit"
], function (domReady, nmCryptokit) {

	//Agnes: Method to recognize browser
	function BrowserInfo() {
		var res = {
			name: "",
			version: "",
		};
		var reg;
		var userAgent = self.navigator.userAgent;

		if (reg = /edge\/([\d\.]+)/i.exec(userAgent)) {
			res.name = "Edge";
			res.version = reg[1];
		}
		else if (/msie/i.test(userAgent)) {
			res.name = "Internet Explorer";
			res.version = /msie ([\d\.]+)/i.exec(userAgent)[1];
		}
		else if (/Trident/i.test(userAgent)) {
			res.name = "Internet Explorer";
			res.version = /rv:([\d\.]+)/i.exec(userAgent)[1];
		}
		else if (/chrome/i.test(userAgent)) {
			res.name = "Chrome";
			res.version = /chrome\/([\d\.]+)/i.exec(userAgent)[1];
		}
		else if (/safari/i.test(userAgent)) {
			res.name = "Safari";
			res.version = /version\/([\d\.]+)/i.exec(userAgent)[1];
		}
		else if (/firefox/i.test(userAgent)) {
			res.name = "Firefox";
			res.version = /firefox\/([\d\.]+)/i.exec(userAgent)[1];
		}
		return res;
	}

	var CryptoKit = null; //instance of the toolkit

	//Agnes: new load method for new version firefox & chrome
	function loadObject() {
		if (CryptoKit) {
			return CryptoKit;
		}

		try {
			var browser = BrowserInfo();
			if (("Chrome" == browser.name && parseInt(browser.version) > 41) ||
				("Firefox" == browser.name && parseInt(browser.version) > 52)) {

				CryptoKit = new nmCryptokit(browser.name);

				CryptoKit.init();

				return CryptoKit;
			}
			else {
				alert("Unsupported browser!");
			}
		}
		catch (e) {
			alert(e);
			return;
		}
	}

	//Agnes: updated selectCertificate
	function selectCertificate(CryptoKit) {
		try {
			var SubjectFilter = "";
			var IssueFilter = "";
			var SerialNO = "";

			var CertSubjectDN = CryptoKit.selectCertificate(SubjectFilter, IssueFilter, SerialNO);
			if (!CertSubjectDN) {
				throw new CFCAAgentException();
			}
		} catch (ex) {
			handleException(ex);
		}
	}

	function getSelectedCertificate(CryptoKit) {
		try {
			var certificate = "";
			//Agnes: the parameter "CertContent" will get the certificate content, and "SubjectDN" will get the certificate SubjectDN,e.g.: CN=041@沈超@DA00456315@1, OU=Individual-1, OU=Bestseller, O=CFCA OCA1, C=CN
			CryptoKit.getSignCertInfo("CertContent")
				.then(function (response) {
					certificate = response.result;
				})
				.catch(function (response) {
					ShowErrorInfo(response, CryptoKit);
				});
			return certificate;
		} catch (ex) {
			handleException(ex);
		}
	}

	function getSignCertInfo(strInfoType) {

		var request = new Object();
		var funcInfo = new Object();
		var paramArr = new Array();
		var randomId = GenerateRandomId();

		paramArr.push(strInfoType);

		funcInfo.function = "GetSignCertInfo";
		funcInfo.params = paramArr;
		funcInfo.randomId = randomId;

		request.action = "invoke";
		request.funcInfo = funcInfo;

		return SendMessage(this.browser, request);
	}

	//Agnes: updated signMessage
	function signMessage(message, CryptoKit) {
		try {
			var signature = "";
			//Agnes: we can use "SHA-1" or "SHA-256" algorithm
			CryptoKit.signMsgPKCS7Attached(message, "SHA-1")
				.then(function (response) {
					signature = response.result;
				})
				.catch(function (response) {
					ShowErrorInfo(response, CryptoKit);
				});

			return signature;
		} catch (ex) {
			handleException(ex);
		}
	}

	function CFCAAgentException() {
		this.message = CryptoKit.GetLastErrorDesc();
	}

	function ShowErrorInfo(response, CryptoKit) {
		if (null == response) {
			alert("Extension has been remove!");
		}
		else if (1 == response.errorcode) { // connection error
			alert(response.result);
		}
		else { // host error
			CryptoKit.getLastErrorDesc()
				.then(function (response) {
					alert(response.result);
				});
		}
	}

	function handleException(ex) {
		if (ex instanceof CFCAAgentException)
			throw ex;
		else
			throw new CFCAAgentException();
	}

	/**
	 * Convenience method to to select certificate and sign a message
	 */
	function selectCertificateAndSignMessage(message, CryptoKit) {
		try {
			selectCertificate(CryptoKit);
			return signMessage(message, CryptoKit);
		} catch (ex) {
			handleException(ex);
		}
	}

	/**
	 * method to record the encrypted signContent to "id" parameter specified attribute, it will publish 2 more sigunature *attributes, one for the encrypted content, one for the original content
	 */
	function doSignature(cn, nodeUrl, id, userCertificateInfo, signContent) {
		try {
			var CryptoKit = loadObject();
			var clientCertificateInfo = "";
			CryptoKit.selectCertificate("", "", "")
				.then(function (response) {
					if (response.result) {
						CryptoKit.getSignCertInfo("CertContent")
							.then(function (response) {
								clientCertificateInfo = response.result;
								clientCertificateInfo = clientCertificateInfo.replace(/[\r\n]/g, "");
								console.log("clientCertificateInfo=" + clientCertificateInfo);
								console.log("userCertificateInfo=" + userCertificateInfo);
								if (clientCertificateInfo != userCertificateInfo) {
									alert("Selected Certificate is inValid!");
									return false;
								} else {
									var signMessage = "";
									//CryptoKit.selectCertificate("", "", "");
									CryptoKit.signMsgPKCS7Attached(signContent, "SHA-1")
										.then(function (response) {
											signMessage = response.result;
											//alert(signMessage);
											cn.writer.changeNode(nodeUrl).publishAttribute(id + ".signContent", "string", signContent, true, false, "0x1", "");
											cn.writer.changeNode(nodeUrl).publishAttribute(id + ".signResult", "string", signMessage, true, false, "0x1", "");
											cn.writer.execute({ sync: true });
										})
										.catch(function (response) {
											ShowErrorInfo(response, CryptoKit);
										});

									return true;
								}
							})
							.catch(function (response) {
								ShowErrorInfo(response, CryptoKit);
							})
					}
				})
				.catch(function (response) {
					ShowErrorInfo(response);
				});

			return true;

		} catch (e) {
			alert("Browser doesn't support Certificate");
			return false;
		}
	}

	/**
	 * Returns true if API is supported in this browser
	 */
	function isSupported(CryptoKit) {
		try {

			CryptoKit.getLastErrorDesc();
			return true;
		} catch (ex) {
		}
		return false;
	}

	/**
	 * public methods and API object
	 */
	return {
		ShowErrorInfo: ShowErrorInfo,
		isSupported: isSupported,
		loadObject: loadObject,
		selectCertificate: selectCertificate,
		getSelectedCertificate: getSelectedCertificate,
		signMessage: signMessage,
		selectCertificateAndSignMessage: selectCertificateAndSignMessage,
		CFCAAgentException: CFCAAgentException,
		doSignature: doSignature
	};
});